
export const DateFormatter = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export const Timestamp = (dateString) => {
    const date = new Date(dateString);

        // Check if the date is invalid
    if (isNaN(date.getTime())) {
        return ''; // Return empty string for invalid dates
    }

    const day = String(date.getUTCDate()).padStart(2, '0'); // Add leading zero for day (UTC)
    const monthNames = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];
    const monthAbbreviation = monthNames[date.getUTCMonth()]; // Get month abbreviation (UTC)
    const year = date.getUTCFullYear(); // Get year (UTC)

    let hours = date.getUTCHours(); // Get hours (UTC)
    const minutes = String(date.getUTCMinutes()).padStart(2, '0'); // Add leading zero for minutes (UTC)
    const seconds = String(date.getUTCSeconds()).padStart(2, '0'); // Add leading zero for seconds (UTC)
    const ampm = hours >= 12 ? 'PM' : 'AM'; // Determine AM or PM

    hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 becomes 12)

    return `${day}-${monthAbbreviation}-${year}, ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`; // Format as DD-MMM-YYYY, HH:MM:SS AM/PM
};

export const safeTimestamp = (dateString) => {

        // Return empty string for null, undefined, or empty input
    if (!dateString) {
        return '';
    }
    // If the input doesn't end with "Z", assume it's UTC and add "Z"
    const fixedDateString = dateString.endsWith("Z") ? dateString : dateString + "Z";

    // Pass the fixed date string to the existing Timestamp function
    return Timestamp(fixedDateString);
};

/**
 * 
 * @param {*} dateString -> 2025-03-19
 * @returns 
 */
export const DateFormatterDDMMMYYYY = (dateString) => {
    if (!dateString) return null;

    const monthNames = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    ];

    let [year, month, day] = dateString.split('-').map(Number);
    day = String(day).padStart(2, '0');
    const monthAbbreviation = monthNames[month-1]; // Get month abbreviation

    return `${day}-${monthAbbreviation}-${year}`;
};